
export interface ProductPrice {
  id?: string;
  tax_id: string;
  name: string;
  available_from: string;
  regular_amount: number;
  amount?: number;
}
